module.exports = __webpack_public_path__ + "static/media/P9.3be40510.png";